import { createAction } from "@reduxjs/toolkit";

export const ADD_MUTUI_BY_ID = createAction("requests/mutui/add-static-mutui");
